import React, { createContext, useEffect, useState } from 'react';
import { useFirebase } from '../hooks';

export const AuthContext = createContext({
    user: null,
    ready: false,
})


export const UserProvider = ({ children }) => {
    const [currentUser, setCurrentUser] = useState({
        ready: false,
        user: null
    })
    const { auth } = useFirebase();

    useEffect(() => {
        if (!auth) {
            return;
        }
        const subscribe = auth.onAuthStateChanged(async (user) => {
            if (!user) {
                return;
            }
            setCurrentUser((currentUser) => ({ ...currentUser, user }));
        });
        return () => subscribe()
    }, [auth])

    return (
        <AuthContext.Provider value={{ ...currentUser }}>{children}</AuthContext.Provider>
    )
}